import React from 'react';

import {Navigate} from 'react-router';

import {LinearProgress} from 'views/components';
import {Helmet} from 'views/module';

import LoomCaregiverListScene from 'views/scenes/caregiver/loom/list/LoomCaregiverList';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomCaregiverList = (props) => {
  const caregiverReadFlag = useFlag(FLAGS.CAREGIVER_READS_FROM_LOOM);

  if (caregiverReadFlag.isLoading) {
    return <LinearProgress color="secondary" />;
  }

  if (!caregiverReadFlag.isEnabled) {
    return <Navigate to="/caregiver" replace />;
  }

  return (
    <>
      <Helmet>
        <title>Quilt: Caregivers Loom</title>
      </Helmet>
      <LoomCaregiverListScene />
    </>
  );
};

export default LoomCaregiverList;
